import ButtonActionsOnUserItems from './ButtonActionsOnUserItems';
import { Button } from '@/components/ui/button.tsx';
import { EllipsisVertical } from 'lucide-react';
import type { IHasClassName } from '@/interfaces';
import type { IUserData } from '@/lib/interface';
import type { TButtonVariant } from '@/types';
import { cn } from '@/lib/utils.ts';
import {
	DropdownMenuContent,
	DropdownMenuTrigger,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenu
} from '@/components/ui';

type TProps = IHasClassName & {
	disableInvalidateQueries?: boolean;
	variant?: TButtonVariant;
	hideText?: boolean;
	user?: IUserData;
	removeItemLocally?: (userId: string) => void;
};

const ButtonActionsOnUser = ({ user, disableInvalidateQueries, className, hideText, variant = 'secondary', removeItemLocally }: TProps) => (
	<DropdownMenu modal={false}>
		<DropdownMenuTrigger asChild>
			<Button
				className={cn(
					'flex items-center space-x-1',
					className
				)}
				variant={variant}
				size={'sm'}>
				{
					!hideText &&
					<p className='text-sm'>
						<span className='block md:hidden'>
							Actions
						</span>
						<span className='hidden md:block'>
							Actions disponibles
						</span>
					</p>
				}
				<EllipsisVertical size={16} />
			</Button>
		</DropdownMenuTrigger>
		<DropdownMenuContent
			className='w-56'
			align='end'>
			{
				user?.roles &&
				<>
					<DropdownMenuGroup>
						<DropdownMenuItem className='text-center text-sm' disabled>
							Cet utilisateur est administrateur
						</DropdownMenuItem>
					</DropdownMenuGroup>
				</>
			}
			{
				user &&
				!user?.roles &&
				<ButtonActionsOnUserItems
					disableInvalidateQueries={disableInvalidateQueries}
					removeItemLocally={removeItemLocally}
					user={user} />
			}
		</DropdownMenuContent>
	</DropdownMenu>
);

export default ButtonActionsOnUser;
